import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";
import AdminSideBar from "./AdminSideBar";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import TrainerSideBar from "./TrainerSideBar";
import ModalManager from "../Modals/ModalManager";

const Layout = ({ sidebar }) => (
    <div className="wrapper">
        {sidebar}
        <div className="main-panel">
            <Header />
            <Outlet />
            <Footer />
        </div>
        <ModalManager width="60vw" />
    </div>
);

Layout.propTypes = {
    sidebar: PropTypes.element.isRequired,
};

const useAuth = (role) => {
    const [isAuthorized, setIsAuthorized] = useState(true);

    useEffect(() => {
        const isLogin = sessionStorage.getItem("isLogin");
        const userRole = sessionStorage.getItem("userRole");

        if (!isLogin || userRole != role) {
            toast.error("You are not allowed to access this Page");
            setIsAuthorized(false);
        }
        else{
            setIsAuthorized(true)
        }
    }, [role]);

    return isAuthorized;
};

export default function TrainerLayout() {
    const isAuthorized = useAuth(2);
    if (!isAuthorized) return <Navigate to={"/"} />;
    return <Layout sidebar={<TrainerSideBar />} />;
}

export function AdminLayout() {
    const isAuthorized = useAuth(1);
    if (!isAuthorized) return <Navigate to={"/"} />;
    return <Layout sidebar={<AdminSideBar />} />;
}

export function StudentLayout() {
    const isAuthorized = useAuth(3);
    if (!isAuthorized) return <Navigate to={"/"} />;
    return <Layout sidebar={<Sidebar />} />;
}
